export const TODO_TYPE = {
	PERSONAL: 'personal',
	ASSIGNED: 'assigned',
};
